<div class="policy-category payment">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <h5 [innerHTML]="textCopy.amountsTitle"></h5>
    <select-question [data]="numberOfRegions.data" [valueSelected]="numberOfRegions.valueSelected"
                     (selectAnswer)="onSelectQuestionSelected($event, numberOfRegions); setContraventionsQuestion()"></select-question>
    <div *ngFor="let regionIndex of [0,1,2]">
      <div class="default-text">What are the PCN charges for region {{regionIndex + 1}}?</div>
      <div class="default-text" *ngFor="let optionIndex of [0,1,2]">
        &#163;
        <input aria-label=""  class="app-input policy-input" type="text" [disabled]="regionIndex > numberOfRegions.valueSelected"
               [(ngModel)]="chargeRegions[regionIndex].options[optionIndex].value" (blur)="setContraventionsQuestion()" />
        <span *ngIf="optionIndex === 0">non-differential</span>
        <span *ngIf="optionIndex === 1">differential: higher</span>
        <span *ngIf="optionIndex === 2">differential: lower</span>
      </div>
    </div>
    <br />
    <div class="default-text" [innerHTML]="textCopy.contranventionsTitle"></div>
    <contraventions-question [valuesSelected]="contraventions.valuesSelected"
                             [options]="contraventions.options"
                             (selectAnswer)="onContraventionsSelected($event)"></contraventions-question>
    <br />
    <div class="default-text">
      <div [innerHTML]="textCopy.revenueAmountTitle"></div>
      &#163; <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="feeAmounts.revenue" />
      <br />
      <div [innerHTML]="textCopy.revenuePercentageTitle"></div>
      <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="feeAmounts.percentContested" /> %
      <br />
      <div [innerHTML]="textCopy.courtFeeTitle"></div>
      &#163; <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="feeAmounts.courtFee" />
      <br />
      <div [innerHTML]="textCopy.courtNewFeeTitle"></div>
      &#163; <input aria-label=""  class="app-input policy-input" type="text" [(ngModel)]="feeAmounts.newCourtFee" />
    </div>
    <br />
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <h5 [innerHTML]="textCopy.refundsTitle"></h5>
    <radio-question [data]="refunds.data" [valueSelected]="refunds.valueSelected"
                    (selectAnswer)="onRadioSelected($event, refunds)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <h5 [innerHTML]="textCopy.instalmentsTitle"></h5>
    <radio-question [data]="instalments.data" [valueSelected]="instalments.valueSelected"
                    (selectAnswer)="onRadioSelected($event, instalments)"></radio-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">4</i>
    <h5 [innerHTML]="textCopy.howPayTitle"></h5>
    <div class="default-text" [innerHTML]="textCopy.howPaySubtitle"></div>
    <div class="default-text" [innerHTML]="textCopy.payExampleLine"></div>
    <br/>
    <div *ngFor="let instruction of payInstructions">
      <input aria-label=""  class="app-input" type="text" [(ngModel)]="instruction.name" />
      <textarea class="app-textarea" [(ngModel)]="instruction.description"></textarea>
    </div>
  </div>

  <div class="policy-item">
    <i class="policy-number">5</i>
    <h5 [innerHTML]="textCopy.reducedChargesTitle"></h5>
    <div class="default-text" [innerHTML]="textCopy.reducedChargesSubtitle"></div>
    <select-question [data]="driverReasonSelect.data" [valueSelected]="driverReasonSelect.valueSelected"
                     (selectAnswer)="onSelectQuestionSelected($event, driverReasonSelect);
                     changeSelectedDriverReason()"></select-question>
    <br/>
    <table>
      <tr *ngFor="let stage of stages; let stageId = index">
        <td class="default-text">{{stage.text}}</td>
        <td>
          <span class="select-layer">
            <select class="app-select" [(ngModel)]="selectedDriverReason.stages[stage.id].option">
              <option *ngFor="let option of stage.options"
                      [value]="option.id">
                {{option.value}}
              </option>
            </select>
          </span>
          <span class="select-layer" [ngClass]="{'disabled': selectedDriverReason.stages[stage.id].option === '0'}">
            <select class="app-select" [disabled]="selectedDriverReason.stages[stage.id].option === '0'"
                    [(ngModel)]="selectedDriverReason.stages[stage.id].time">
              <option *ngFor="let time of stage.times"
                      [value]="time.id">
                {{time.value}}
              </option>
            </select>
          </span>
        </td>
      </tr>
    </table>
  </div>

  <div class="policy-item">
    <i class="policy-number">6</i>
    <h5 [innerHTML]="textCopy.otherTitle"></h5>
    <radio-question [data]="payFullPolicy.data" [valueSelected]="payFullPolicy.valueSelected"
                    (selectAnswer)="onRadioSelected($event, payFullPolicy)"></radio-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
